"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.string.iterator");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));

require("core-js/modules/es6.array.find-index");

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.array.find");

require("core-js/modules/web.dom.iterable");

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

require("core-js/modules/es6.regexp.split");

var _toConsumableArray2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/toConsumableArray.js"));

var _xlsx = _interopRequireDefault(require("xlsx"));

var _exceljs = _interopRequireDefault(require("exceljs"));

var _vuedraggable = _interopRequireDefault(require("vuedraggable"));

var _installTask = require("@/api/cms/installTask");

var _dictDetail = require("@/api/system/dictDetail");

var _index = require("@/utils/index");

var _index2 = _interopRequireDefault(require("./feeInfo/index"));

var _index3 = _interopRequireDefault(require("./taskInfo/index"));

var _index4 = _interopRequireDefault(require("./operationRecord/index"));

var _index5 = _interopRequireDefault(require("./clockInRecord/index"));

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }

function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }

function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var _default = {
  name: 'InstallManagement',
  components: {
    FeeInfo: _index2.default,
    TaskInfo: _index3.default,
    OperationRecord: _index4.default,
    ClockInRecord: _index5.default,
    draggable: _vuedraggable.default
  },
  dicts: ['install_list_display_fields'],
  created: function created() {
    var _this = this;

    this.$on('dictReady', function () {
      _this.initTableHeader();
    });
  },
  data: function data() {
    return {
      searchLoading: false,
      searchForm: {
        installCode: '',
        contractNo: '',
        status: null,
        customer: '',
        customerAddress: '',
        installPerson: ''
      },
      statistics: {
        total: 0,
        pendingSubmit: 0,
        pendingInstall: 0,
        installing: 0,
        completed: 0
      },
      activeStatus: null,
      tableData: [],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      selectedRows: [],
      screenWidth: document.documentElement.clientWidth || document.body.clientWidth,
      screenHeight: document.documentElement.clientHeight || document.body.clientHeight,
      detailVisible: false,
      detailRow: null,
      detailActiveTab: 'log',
      detailFeeList: [],
      detailTaskList: [],
      tableHeader: [],
      configDialogVisible: false,
      originalHeaderConfig: [],
      tableRenderKey: 0
    };
  },
  computed: {
    dialogWidth: function dialogWidth() {
      return this.screenWidth * 0.7 + 'px';
    },
    tableHeight: function tableHeight() {
      return this.screenHeight * 0.55;
    },
    visibleColumns: {
      get: function get() {
        return this.tableHeader.filter(function (col) {
          return col.visible;
        });
      },
      set: function set(val) {
        this.tableHeader = [].concat((0, _toConsumableArray2.default)(val), (0, _toConsumableArray2.default)(this.tableHeader.filter(function (col) {
          return !col.visible;
        })));
        this.tableRenderKey++;
      }
    }
  },
  watch: {
    tableHeader: {
      handler: function handler() {
        this.tableRenderKey++;
      },
      deep: true
    }
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.handleResize);
    this._isMounted = true;
    this.applyRouteStatus();
    this.loadData();
    this.loadStatistics();
  },
  activated: function activated() {
    if (this._isMounted) {
      this._isMounted = false;
      return;
    }

    this.applyRouteStatus();
    this.loadData();
    this.loadStatistics();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize: function handleResize() {
      this.screenWidth = document.documentElement.clientWidth || document.body.clientWidth;
      this.screenHeight = document.documentElement.clientHeight || document.body.clientHeight;
    },
    applyRouteStatus: function applyRouteStatus() {
      var statusMap = {
        '待提交': 0,
        '待安装': 10,
        '安装中': 20,
        '完成': 40
      };
      var status = this.$route.query.status;

      if (status && status !== '') {
        var numericStatus = statusMap[status];

        if (numericStatus !== undefined) {
          this.searchForm.status = numericStatus;
          this.activeStatus = numericStatus;
          return;
        }
      }

      this.searchForm.status = null;
      this.activeStatus = null;
    },
    formatDate: function formatDate(dateStr) {
      if (!dateStr) return '';
      return dateStr.split(' ')[0];
    },
    getDesignSchemeTotalPackages: function getDesignSchemeTotalPackages(ds) {
      if (!ds.orderSolutions || ds.orderSolutions.length === 0) return 0;
      return ds.orderSolutions.reduce(function (sum, os) {
        return sum + (os.packages || 0);
      }, 0);
    },
    loadData: function loadData() {
      var _this2 = this;

      this.searchLoading = true;
      var params = {
        page: this.pagination.page - 1,
        size: this.pagination.pageSize
      };

      if (this.searchForm.installCode) {
        params.installCode = this.searchForm.installCode;
      }

      if (this.searchForm.contractNo) {
        params.contractNo = this.searchForm.contractNo;
      }

      if (this.searchForm.status !== undefined && this.searchForm.status !== null) {
        params.status = this.searchForm.status;
      }

      if (this.searchForm.customer) {
        params.customer = this.searchForm.customer;
      }

      if (this.searchForm.customerAddress) {
        params.customerAddress = this.searchForm.customerAddress;
      }

      if (this.searchForm.installPerson) {
        params.installPerson = this.searchForm.installPerson;
      }

      return (0, _installTask.getInstallTaskList)(params).then(function (response) {
        if (response.code === 200) {
          var rawList = response.data.content || [];
          _this2.tableData = rawList.map(function (item) {
            return _objectSpread(_objectSpread({}, item), {}, {
              contractList: (item.contractList || []).map(function (contract) {
                return _objectSpread(_objectSpread({}, contract), {}, {
                  _deliveryId: item.id,
                  _rowKey: "".concat(item.id, "_").concat(contract.id),
                  designSchemes: (contract.designSchemes || []).map(function (ds) {
                    return _objectSpread(_objectSpread({}, ds), {}, {
                      _rowKey: "".concat(item.id, "_").concat(contract.id, "_").concat(ds.id),
                      orderSolutions: (ds.orderSolutions || []).map(function (os) {
                        return _objectSpread(_objectSpread({}, os), {}, {
                          _rowKey: "".concat(item.id, "_").concat(contract.id, "_").concat(ds.id, "_").concat(os.id)
                        });
                      })
                    });
                  })
                });
              })
            });
          });
          _this2.pagination.total = response.data.totalElements;
        }
      }).finally(function () {
        _this2.searchLoading = false;
      });
    },
    loadStatistics: function loadStatistics() {
      var _this3 = this;

      (0, _installTask.getInstallTaskStatistics)().then(function (response) {
        if (response.code === 200) {
          var data = response.data;
          _this3.statistics = {
            total: data.all || 0,
            pendingSubmit: data.pendingSubmit || 0,
            pendingInstall: data.pendingInstall || 0,
            installing: data.installing || 0,
            completed: data.completed || 0
          };
        }
      }).catch(function () {});
    },
    handleExport: function handleExport() {
      var _this4 = this;

      var params = {};

      if (this.searchForm.installCode) {
        params.installCode = this.searchForm.installCode;
      }

      if (this.searchForm.contractNo) {
        params.contractNo = this.searchForm.contractNo;
      }

      if (this.searchForm.status !== undefined && this.searchForm.status !== null) {
        params.status = this.searchForm.status;
      }

      if (this.searchForm.customer) {
        params.customer = this.searchForm.customer;
      }

      if (this.searchForm.customerAddress) {
        params.customerAddress = this.searchForm.customerAddress;
      }

      if (this.searchForm.installPerson) {
        params.installPerson = this.searchForm.installPerson;
      }

      (0, _installTask.exportInstallTaskList)(params).then(function (res) {
        (0, _index.downloadFile)(res, '安装任务列表', 'xlsx');

        _this4.$message.success('导出成功');
      }).catch(function () {
        _this4.$message.error('导出失败');
      });
    },
    handleSearch: function handleSearch() {
      this.pagination.page = 1;
      this.loadData();
    },
    resetSearch: function resetSearch() {
      this.searchForm = {
        installCode: '',
        contractNo: '',
        status: null,
        customer: '',
        customerAddress: '',
        installPerson: ''
      };
      this.activeStatus = null;
      this.handleSearch();
    },
    handleCardClick: function handleCardClick(status) {
      this.activeStatus = status;
      this.searchForm.status = status;
      this.handleSearch();
    },
    getStatusLabel: function getStatusLabel(status) {
      var map = {
        0: '待提交',
        1: '待审核',
        10: '待预约',
        20: '待上门',
        30: '待服务',
        40: '待完工',
        50: '待完成'
      };
      return map[status] || '未知';
    },
    getStatusType: function getStatusType(status) {
      var map = {
        0: 'info',
        1: 'warning',
        10: 'primary',
        20: 'primary',
        30: 'primary',
        40: 'warning',
        50: 'success'
      };
      return map[status] || 'info';
    },
    getContractStatusType: function getContractStatusType(status) {
      if (status >= 70) return 'success';
      if (status >= 50) return 'primary';
      if (status >= 30) return 'warning';
      return 'info';
    },
    initTableHeader: function initTableHeader() {
      var fields = this.dict.install_list_display_fields.filter(function (item) {
        return item.value && item.label;
      });
      this.tableHeader = fields.map(function (item, index) {
        return {
          key: item.value,
          label: item.label,
          visible: item.unit !== false && item.unit !== 'false',
          sort: item.dictSort || index
        };
      });
      this.loadHeaderConfig();
    },
    loadHeaderConfig: function loadHeaderConfig() {
      var _this5 = this;

      if (!this.tableHeader || this.tableHeader.length === 0) return;
      var savedConfig = localStorage.getItem('installHeaderConfig');

      if (savedConfig) {
        try {
          var config = JSON.parse(savedConfig);
          config.forEach(function (item) {
            var col = _this5.tableHeader.find(function (col) {
              return col.key === item.key;
            });

            if (col) {
              col.visible = item.visible;
              col.sort = item.sort !== undefined ? item.sort : col.sort;
            }
          });
          this.tableHeader.sort(function (a, b) {
            return a.sort - b.sort;
          });
        } catch (e) {
          console.error('加载表头配置失败:', e);
        }
      }
    },
    isColumnVisible: function isColumnVisible(key) {
      var col = this.tableHeader.find(function (c) {
        return c.key === key;
      });
      return col ? col.visible : true;
    },
    toggleColumnVisible: function toggleColumnVisible(key) {
      var idx = this.tableHeader.findIndex(function (c) {
        return c.key === key;
      });

      if (idx !== -1) {
        this.$set(this.tableHeader[idx], 'visible', !this.tableHeader[idx].visible);
        this.tableRenderKey++;
      }
    },
    getColumnValue: function getColumnValue(key, row) {
      if (!row) return '-';

      if (key === 'status') {
        return this.getStatusLabel(row.status);
      }

      if (key === 'installDate') {
        return this.formatDate(row.installDate);
      }

      return row[key] || '-';
    },
    getStrWidth: function getStrWidth(str) {
      var width = 0;

      var _iterator = _createForOfIteratorHelper(String(str)),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var char = _step.value;

          if (/[\u4e00-\u9fa5]/.test(char)) {
            width += 24;
          } else if (/[0-9]/.test(char)) {
            width += 10;
          } else {
            width += 10;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return width;
    },
    getColumnWidth: function getColumnWidth(key) {
      var _this6 = this;

      if (!this.tableData || this.tableData.length === 0) {
        return 140;
      }

      var col = this.tableHeader.find(function (c) {
        return c.key === key;
      });
      var headerWidth = this.getStrWidth(col ? col.label : key);
      var values = this.tableData.map(function (row) {
        return _this6.getColumnValue(key, row) || '';
      });
      var dataWidth = Math.max.apply(Math, (0, _toConsumableArray2.default)(values.map(function (v) {
        return _this6.getStrWidth(v);
      })));
      var maxWidth = Math.max(headerWidth, dataWidth);
      var minWidth = 80;
      return Math.max(maxWidth + 20, minWidth);
    },
    moveAllToLeft: function moveAllToLeft() {
      this.tableHeader.forEach(function (col) {
        col.visible = false;
      });
      this.tableHeader = (0, _toConsumableArray2.default)(this.tableHeader);
      this.tableRenderKey++;
    },
    moveAllToRight: function moveAllToRight() {
      this.tableHeader.forEach(function (col) {
        col.visible = true;
      });
      this.tableHeader = (0, _toConsumableArray2.default)(this.tableHeader);
      this.tableRenderKey++;
    },
    openConfigDialog: function openConfigDialog() {
      this.originalHeaderConfig = this.tableHeader.map(function (col, index) {
        return {
          key: col.key,
          visible: col.visible,
          sort: index
        };
      });
      this.configDialogVisible = true;
    },
    saveHeaderConfig: function () {
      var _saveHeaderConfig = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this7 = this;

        var config, dictData, updatePromises;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                config = this.tableHeader.map(function (col, index) {
                  return {
                    key: col.key,
                    visible: col.visible,
                    sort: index
                  };
                });
                localStorage.setItem('installHeaderConfig', JSON.stringify(config));
                dictData = this.dict.install_list_display_fields;
                updatePromises = [];
                config.forEach(function (item, index) {
                  var originalItem = _this7.originalHeaderConfig.find(function (o) {
                    return o.key === item.key;
                  });

                  if (originalItem && (originalItem.visible !== item.visible || originalItem.sort !== index)) {
                    var dictItem = dictData.find(function (d) {
                      return d.value === item.key;
                    });

                    if (dictItem && dictItem.id) {
                      updatePromises.push((0, _dictDetail.edit)({
                        id: dictItem.id,
                        dict: {
                          id: dictItem.dict.id
                        },
                        value: dictItem.value,
                        label: dictItem.label,
                        unit: item.visible,
                        dictSort: index
                      }));
                    }
                  }
                });

                if (!(updatePromises.length > 0)) {
                  _context.next = 20;
                  break;
                }

                _context.prev = 6;
                _context.next = 9;
                return Promise.all(updatePromises);

              case 9:
                this.$message.success('配置已保存');
                this.$nextTick(function () {
                  _this7.handleSearch();
                });
                _context.next = 18;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](6);
                console.error('保存字典配置失败:', _context.t0);
                this.$message.warning('本地保存成功，但服务器保存失败');
                this.$nextTick(function () {
                  _this7.handleSearch();
                });

              case 18:
                _context.next = 22;
                break;

              case 20:
                this.$message.success('配置已保存');
                this.$nextTick(function () {
                  _this7.handleSearch();
                });

              case 22:
                this.configDialogVisible = false;

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 13]]);
      }));

      function saveHeaderConfig() {
        return _saveHeaderConfig.apply(this, arguments);
      }

      return saveHeaderConfig;
    }(),
    resetHeaderConfig: function resetHeaderConfig() {
      var fields = this.dict.install_list_display_fields.filter(function (item) {
        return item.value && item.label;
      });
      var newTableHeader = fields.map(function (item, index) {
        return {
          key: item.value,
          label: item.label,
          visible: item.unit !== false && item.unit !== 'false',
          sort: item.dictSort || index
        };
      });
      newTableHeader.sort(function (a, b) {
        return a.sort - b.sort;
      });
      this.tableHeader = newTableHeader;
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.selectedRows = val;
    },
    handleRowClick: function handleRowClick(row) {
      this.$refs.mainTable.toggleRowExpansion(row);
    },
    handleContractRowClick: function handleContractRowClick(row, tableRef) {
      var ref = this.$refs[tableRef];

      if (ref) {
        ref.toggleRowExpansion(row);
      }
    },
    handleDesignRowClick: function handleDesignRowClick(row, tableRef) {
      var ref = this.$refs[tableRef];

      if (ref) {
        ref.toggleRowExpansion(row);
      }
    },
    handleCheckChange: function handleCheckChange(row) {
      console.log('checked:', row.checked, row);
    },
    handleAddress: function handleAddress() {
      this.$message.info('收货地址功能开发中');
    },
    handleCreate: function handleCreate() {
      this.$message.info('创建发货单功能开发中');
    },
    handleView: function handleView(row) {
      this.$message.info('查看功能开发中');
    },
    handleShowDetail: function handleShowDetail(row) {
      this.detailRow = row;
      this.detailFeeList = row.feeList || [];
      this.detailTaskList = row.taskList ? row.taskList : [row];
      this.detailActiveTab = 'log';
      this.detailVisible = true;
    },
    handleFeeRefresh: function handleFeeRefresh() {
      var _this8 = this;

      this.loadData().then(function () {
        if (_this8.detailVisible && _this8.detailRow) {
          var updated = _this8.tableData.find(function (item) {
            return item.id === _this8.detailRow.id;
          });

          if (updated) {
            _this8.detailRow = updated;
            _this8.detailFeeList = updated.feeList || [];
          }
        }
      });
    },
    handleTaskRefresh: function handleTaskRefresh() {
      var _this9 = this;

      this.loadData().then(function () {
        if (_this9.detailVisible && _this9.detailRow) {
          var updated = _this9.tableData.find(function (item) {
            return item.id === _this9.detailRow.id;
          });

          if (updated) {
            _this9.detailRow = updated;
            _this9.detailTaskList = updated.taskList || [updated];
          }
        }
      });
    },
    handleEdit: function handleEdit(row) {
      this.detailVisible = false;
      sessionStorage.setItem('install_editData', JSON.stringify(row));
      this.$router.push({
        path: '/cms/install/create',
        query: {
          editId: row.id
        }
      });
    },
    handleSubmit: function handleSubmit(row, status) {
      var _this10 = this;

      var actionMap = {
        1: '提交',
        10: '审核',
        0: '取消'
      };
      var actionLabel = actionMap[status] || '操作';
      this.$confirm("\u786E\u5B9A".concat(actionLabel, "\u5B89\u88C5\u5DE5\u5355 ").concat(row.installCode, " \u5417\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '返回',
        type: 'warning'
      }).then(function () {
        (0, _installTask.updateInstallTaskStatus)(row.id, {
          status: status
        }).then(function (response) {
          if (response.code === 200) {
            _this10.$message.success("".concat(actionLabel, "\u6210\u529F"));

            _this10.loadData();
          } else {
            _this10.$message.error(response.msg || "".concat(actionLabel, "\u5931\u8D25"));
          }
        }).catch(function () {
          _this10.$message.error("".concat(actionLabel, "\u5931\u8D25"));
        });
      }).catch(function () {});
    },
    handleDelete: function handleDelete(row) {
      var _this11 = this;

      this.$confirm("\u786E\u5B9A\u5220\u9664\u5B89\u88C5\u5DE5\u5355 ".concat(row.installCode, " \u5417\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '返回',
        type: 'warning'
      }).then(function () {
        (0, _installTask.deleteInstallTask)(row.id).then(function (response) {
          if (response.code === 200) {
            _this11.$message.success('删除成功');

            _this11.loadData();
          } else {
            _this11.$message.error(response.msg || '删除失败');
          }
        }).catch(function () {
          _this11.$message.error('删除失败');
        });
      }).catch(function () {});
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pagination.page = 1;
      this.pagination.pageSize = val;
      this.loadData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pagination.page = val;
      this.loadData();
    },
    handleExportNote: function handleExportNote(row) {
      var self = this;
      var allSchemes = [];

      if (row.contractList) {
        row.contractList.forEach(function (contract) {
          if (contract.designSchemes) {
            contract.designSchemes.forEach(function (ds) {
              allSchemes.push({
                contract: contract,
                scheme: ds
              });
            });
          }
        });
      }

      if (allSchemes.length === 0) {
        self.$message.warning('暂无出货单数据');
        return;
      }

      var loading = self.$loading({
        lock: true,
        text: '正在生成出货单，请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      var companyName = '广西爱阁工房家居有限责任公司';
      var deliveryNo = '安装工单：' + row.installCode;
      var headers = ['序号', '区域', '客户', '电话', '地址', '销售单号', '合同号', '产品名称', '生产单号', '颗粒板', '颗粒门', '爱格板', 'A2225板', '圆弧装饰柜', '切割类护墙板', '房门', '轨道', '移门', '铝框门', '膜压', '实木', '烤漆门', '台面', '台面岩板', '标准五金', '大五金', '切割五金', '外购玻璃', '非标五金', '发光灯', '斜边门', '全隐门A', '全隐门型材', '特殊五金', '隐形门', '自动线', '藤编门', '铝蜂窝板', '炭岩板', '油漆产品', '拼框门', '柜体板', '装饰线', '圆弧门', '小计', '备注'];
      var materialCols = ['颗粒板', '颗粒门', '爱格板', 'A2225板', '圆弧装饰柜', '切割类护墙板', '房门', '轨道', '移门', '铝框门', '膜压', '实木', '烤漆门', '台面', '台面岩板', '标准五金', '大五金', '切割五金', '外购玻璃', '非标五金', '发光灯', '斜边门', '全隐门A', '全隐门型材', '特殊五金', '隐形门', '自动线', '藤编门', '铝蜂窝板', '炭岩板', '油漆产品', '拼框门', '柜体板', '装饰线', '圆弧门'];
      var totalCols = headers.length;

      function colToLetter(col) {
        var letter = '';

        while (col > 0) {
          var mod = (col - 1) % 26;
          letter = String.fromCharCode(65 + mod) + letter;
          col = Math.floor((col - 1) / 26);
        }

        return letter;
      }

      var workbook = new _exceljs.default.Workbook();
      var worksheet = workbook.addWorksheet('出货单');
      var endCol = colToLetter(totalCols);
      worksheet.mergeCells('A1:' + endCol + '1');
      worksheet.mergeCells('A2:' + endCol + '2');
      var companyCell = worksheet.getCell('A1');
      companyCell.value = companyName;
      companyCell.font = {
        size: 20,
        bold: true
      };
      companyCell.alignment = {
        horizontal: 'center',
        vertical: 'middle'
      };
      var deliveryCell = worksheet.getCell('A2');
      deliveryCell.value = deliveryNo;
      deliveryCell.font = {
        size: 14,
        bold: true
      };
      deliveryCell.alignment = {
        horizontal: 'center',
        vertical: 'middle'
      };
      worksheet.addRow(headers);
      allSchemes.forEach(function (item, index) {
        var contract = item.contract;
        var scheme = item.scheme;
        var materialValues = {};

        if (scheme.orderSolutions) {
          scheme.orderSolutions.forEach(function (os) {
            var name = os.solutionName || '';
            var val = os.packages != null ? os.packages : os.area != null ? os.area : 0;
            materialValues[name] = val;
          });
        }

        var materialValuesArr = materialCols.map(function (col) {
          var val = materialValues[col];
          var num = Number(val);
          return !isNaN(num) ? num : val != null ? val : '';
        });
        var rowData = [index + 1, contract.area || contract.region || '', contract.contactPerson || '', contract.contactNumber || '', contract.contactAddress || '', scheme.productionOrder || '', contract.contractNo || '', scheme.detailName || scheme.solutionName || scheme.productionOrder || '', scheme.productionOrder || ''].concat(materialValuesArr).concat([materialValuesArr.reduce(function (sum, v) {
          return sum + (typeof v === 'number' ? v : 0);
        }, 0), contract.remark || scheme.remark || '']);
        worksheet.addRow(rowData);
      });

      function getDisplayWidth(str) {
        if (!str && str !== 0) return 0;
        str = String(str);
        var width = 0;

        for (var i = 0; i < str.length; i++) {
          width += str.charCodeAt(i) > 255 ? 2.2 : 1.1;
        }

        return width;
      }

      var colMaxWidths = [];

      for (var c = 1; c <= totalCols; c++) {
        colMaxWidths[c] = 0;
      }

      worksheet.eachRow({
        includeEmpty: false
      }, function (row) {
        row.eachCell(function (cell, colNumber) {
          var w = getDisplayWidth(cell.value);

          if (w > colMaxWidths[colNumber]) {
            colMaxWidths[colNumber] = w;
          }
        });
      });
      worksheet.columns.forEach(function (col, i) {
        col.width = Math.max(colMaxWidths[i + 1] + 1, 4);
      });
      worksheet.eachRow({
        includeEmpty: false
      }, function (row, rowNumber) {
        if (rowNumber === 1) {
          row.height = 50;
        } else if (rowNumber === 2) {
          row.height = 30;
        } else {
          row.height = 24;
        }

        row.eachCell(function (cell, colNumber) {
          cell.alignment = {
            horizontal: 'center',
            vertical: 'middle'
          };
          cell.border = {
            top: {
              style: 'thin'
            },
            left: {
              style: 'thin'
            },
            bottom: {
              style: 'thin'
            },
            right: {
              style: 'thin'
            }
          };
        });
      });
      workbook.xlsx.writeBuffer().then(function (buffer) {
        var blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        var url = window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = url;
        link.download = '出货单_' + row.installCode + '.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        loading.close();
        self.$message.success('出货单导出成功');
      }).catch(function (err) {
        loading.close();
        self.$message.error('出货单导出失败');
      });
    }
  }
};
exports.default = _default;